<template>

    <wizard-step-card
            header="Bitte geben Sie weitere Details an!"
            :reason="_getCurrentReason"
            v-on:stepdone="stepDone"
            v-on:abbort="$emit('abbort')"
    >

        <div class="row">

            <div class="col-lg-6 col-xs-12 border-1">

                <info-header icon="far fa-edit">
                    <template slot="titel">
                        Beschreiben Sie den Zustand des Artikels
                    </template>

                    <template slot="leed">
                        Bitte beschreiben Sie so detailliert wie möglich, was an Ihrem Artikel defekt ist
                        oder welche Teile in der Lieferung  fehlen!
                    </template>
                </info-header>

                <customer-discription name="problemDiscription" v-on:setText="_setText"> </customer-discription>

            </div>

            <div class="col-lg-6 col-xs-12 border-1">

                <info-header icon="fas fa-camera-retro">
                    <template slot="titel">
                        Laden Sie Fotos des Artikels und Karton hoch
                    </template>

                    <template slot="leed">
                        Bitte laden Sie mindestens 3 Bilder hoch, auf denen der Zustand des gelieferten Artikels und des Kartons gut zu sehen sind.
                    </template>
                </info-header>

                <div class="row">
                    <div class="col-lg-6 col-xs-12">
                        <image-file-select name="image1" v-on:setimage="_setImage"></image-file-select>
                        <image-file-select name="image2" v-on:setimage="_setImage"></image-file-select>
                        <image-file-select name="image3" v-on:setimage="_setImage"></image-file-select>
                    </div>
                    <div class="col-lg-6 col-xs-12">
                        <image-file-select name="image4" v-on:setimage="_setImage"></image-file-select>
                        <image-file-select name="image5" v-on:setimage="_setImage"></image-file-select>
                        <image-file-select name="image6" v-on:setimage="_setImage"></image-file-select>
                    </div>
                </div>

            </div>

        </div>

    </wizard-step-card>

</template>

<script>
    import ImageFileSelect from '../../elements/ImageFileSelect'
    import CustomerDiscription from '../../elements/CustomerDiscription'
    import InfoHeader from '../../elements/InfoHeader'
    import WizardStepCard from '../../elements/WizardStepCard'

    export default {
        name: "problem-form",
        components: {
            ImageFileSelect,
            CustomerDiscription,
            InfoHeader,
            WizardStepCard
        },
        computed: {
            _getCurrentReason () {

                let reasonCode = this.$store.getters.getReason

                return this.$store.getters.getReasons[ reasonCode ] || 'Fehler - nicht gefunden!'
            }
        },

        methods:    {
            _setImage (obj) {

                let { name, value } = obj

                this.$store.commit('setImage', { name, value })
            },

            _setText (obj) {

                let { name, value } = obj

                this.$store.commit('setText', { name, value })
            },

            stepDone () {

                // Form validation
                const form = this.$store.getters.getForm

                // Check text && length
                if( !form.text.problemDiscription || form.text.problemDiscription < 20 ){
                    this.$swal({
                        title: 'Beschreibung',
                        text: 'Ihre Beschreibung enthält zu wenige Zeichen!',
                        icon: 'error'
                    })

                    return
                }

                // Check images
                if( Object.values(form.images).filter(x => x === false).length > 3 ){
                    this.$swal({
                        title: 'FOTOS',
                        text: 'Es wurden nicht mindestens 3 alle Bilder geladen!',
                        icon: 'error'
                    })

                    return
                }

                this.$emit('stepdone')
            }
        }
    }
</script>

<style scoped>
    .card-header.leed { font-size: 0.8em }
</style>